import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import compose from '../../hoc/compose';
import Slider from '../slider/slider';
import displayNames from '../displayNames';
var OpacityPicker = function OpacityPicker(props) {
  return /*#__PURE__*/React.createElement(Slider, _.defaults({
    className: props.getClassName('opacity-slider')
  }, props));
};
OpacityPicker.displayName = displayNames.OPACITY_PICKER;
OpacityPicker.propTypes = {
  /**
   * Automation ID - for testing purposes, please use dataHook instead
   * @deprecated
   */
  automationId: PropTypes.string,
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  value: PropTypes.number,
  opacityGradientColor: PropTypes.string,
  onChange: PropTypes.func,
  onSlideStart: PropTypes.func,
  onSlideEnd: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  unit: PropTypes.oneOf(['percent', ''])
};
OpacityPicker.defaultProps = {
  value: 100,
  opacityGradientColor: 'white',
  step: 1,
  min: 0,
  max: 100,
  unit: 'percent'
};
export default compose(OpacityPicker);